import { g as A } from "./index767.mjs";
import { f as M } from "./index841.mjs";
import { f as T } from "./index816.mjs";
import { i as $ } from "./index761.mjs";
import { h as w } from "./index811.mjs";
import { f as D } from "./index758.mjs";
import { h as L } from "./index842.mjs";
import { a as O } from "./index843.mjs";
import { d as N } from "./index844.mjs";
import { v as _ } from "./index845.mjs";
import { e as x } from "./index846.mjs";
import { e as k } from "./index772.mjs";
var a = A, F = M, P = T, u = $, q = w, E = D, g = L, B = O, d = N, G = _, H = x, R = k, c = a.setImmediate, v = a.clearImmediate, Y = a.process, s = a.Dispatch, j = a.Function, h = a.MessageChannel, z = a.String, i = 0, n = {}, I = "onreadystatechange", o, t, m, f;
E(function() {
  o = a.location;
});
var p = function(e) {
  if (q(n, e)) {
    var r = n[e];
    delete n[e], r();
  }
}, l = function(e) {
  return function() {
    p(e);
  };
}, C = function(e) {
  p(e.data);
}, S = function(e) {
  a.postMessage(z(e), o.protocol + "//" + o.host);
};
(!c || !v) && (c = function(r) {
  G(arguments.length, 1);
  var b = u(r) ? r : j(r), y = B(arguments, 1);
  return n[++i] = function() {
    F(b, void 0, y);
  }, t(i), i;
}, v = function(r) {
  delete n[r];
}, R ? t = function(e) {
  Y.nextTick(l(e));
} : s && s.now ? t = function(e) {
  s.now(l(e));
} : h && !H ? (m = new h(), f = m.port2, m.port1.onmessage = C, t = P(f.postMessage, f)) : a.addEventListener && u(a.postMessage) && !a.importScripts && o && o.protocol !== "file:" && !E(S) ? (t = S, a.addEventListener("message", C, !1)) : I in d("script") ? t = function(e) {
  g.appendChild(d("script"))[I] = function() {
    g.removeChild(this), p(e);
  };
} : t = function(e) {
  setTimeout(l(e), 0);
});
var ne = {
  set: c,
  clear: v
};
export {
  ne as t
};
